import { createFileRoute } from '@tanstack/react-router'
import { MarketingPage } from '@/features/marketing/components/marketing-page'
import { enContent } from '@/features/marketing/content'

export const Route = createFileRoute('/en/contact')({
  component: EnContactPage,
})

function EnContactPage() {
  return <MarketingPage {...enContent.contact} />
}
